import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../common/branding/colors';

type StyleType = {
    backgroundColor: string;
    border: string;
    txtColor: string;
    iconColor: string;
    color: string;
};

type NotifierTypeMap = {
    INFO: StyleType;
    WARNING: StyleType;
    ERROR: StyleType;
};

type NotifierType = {
    type: keyof NotifierTypeMap;
};

export const NOTIFIER_TYPE_MAP: NotifierTypeMap = {
    INFO: {
        backgroundColor: COLORS.pastelSecondary100,
        border: `1px solid ${COLORS.primary300}`,
        txtColor: COLORS.neutral900,
        iconColor: COLORS.pastelSecondary100,
        color: 'inherit',
    },
    WARNING: {
        backgroundColor: '#FFFBF2',
        border: `1px solid ${COLORS.banana700}`,
        txtColor: 'inherit',
        color: COLORS.neutral900,
        iconColor: COLORS.banana700,
    },
    ERROR: {
        backgroundColor: COLORS.pastelDanger300,
        border: `1px solid ${COLORS.danger300}`,
        txtColor: 'inherit',
        color: COLORS.danger300,
        iconColor: 'inherit',
    },
};

export const NotifierWrapper = styled.div`
    position: absolute;
    bottom: 6px;
    left: 0;
    right: 0;
    width: inherit;
    display: flex;
    justify-content: center;
`;

export const NotifierBox = styled.div<NotifierType>`
    z-index: 4;
    background: ${({ type }) => NOTIFIER_TYPE_MAP[type].backgroundColor};
    border: ${({ type }) => NOTIFIER_TYPE_MAP[type].border};
    padding: 8px;
    font-size: 13px;
    width: fit-content;
    color: ${({ type }) => NOTIFIER_TYPE_MAP[type].color};
`;

export const Icon = styled(FontAwesomeIcon)<NotifierType>`
    margin: 0 6px;
    color: ${({ type }) => NOTIFIER_TYPE_MAP[type].iconColor};
`;

export const CloseIcon = styled(FontAwesomeIcon)`
    cursor: pointer;
    color: ${({ theme }) => theme.colors.neutral100};
    float: right;
    margin-top: 3px;
    margin-left: 8px;
`;
